import axios from 'axios'
import { Notification,Progress } from 'element-ui';
import store from '../store'
console.log(store)
let type
axios.interceptors.response.use(function (response) {
  // Do something with response data
  type = response.headers['content-type']
  return response;
}, function (error) {
  // Do something with response error
  return Promise.reject(error);
});
// 导出Excel公用方法
function exportMethod (url, name) {
  axios.get(url, {
    responseType: 'blob', // 或者responseType: 'blob'
    xsrfHeaderName: 'Authorization',
    headers: {
      'token': localStorage.getItem("accessKey"),
    },
    onDownloadProgress: (evt) => {
      // console.log("progressEvent===",evt )
      // 对原生进度事件的处理
      if(parseInt((evt.loaded / evt.total) * 100)==100){
        store.commit('progress/COMMIT_DATA',{show:false,progress:parseInt((evt.loaded / evt.total) * 100)})
      }
      else if(parseInt((evt.loaded / evt.total) * 100)==0){
        store.commit('progress/COMMIT_DATA',{show:true,progress:parseInt((evt.loaded / evt.total) * 100)})
      }
      else{
        store.commit('progress/COMMIT_DATA',{show:store.state.progress.show,progress:parseInt((evt.loaded / evt.total) * 100)})
      }
    }
      // this.setState({ progress: parseInt((evt.loaded / evt.total) * 100) });

  }).then(res => {
    let a = document.createElement("a");
    const blob = new Blob([res.data], {
      type: type
    })
    a.href = URL.createObjectURL(blob);
    console.log(name)
    a.download = name //xxxx 就是指定的文件名
    a.click()
  }).catch(err => {
    console.log(err)
  })
}
export default exportMethod